// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountTypeFilterController from "./account_type_filter_controller"
application.register("account-type-filter", AccountTypeFilterController)

import AiClassificationController from "./ai_classification_controller"
application.register("ai-classification", AiClassificationController)

import AiGenerationController from "./ai_generation_controller"
application.register("ai-generation", AiGenerationController)

import AnalysisPollingController from "./analysis_polling_controller"
application.register("analysis-polling", AnalysisPollingController)

import BalanceToggleController from "./balance_toggle_controller"
application.register("balance-toggle", BalanceToggleController)

import BatchUploadController from "./batch_upload_controller"
application.register("batch-upload", BatchUploadController)

import ClientSelectorController from "./client_selector_controller"
application.register("client-selector", ClientSelectorController)

import CurrencyToggleController from "./currency_toggle_controller"
application.register("currency-toggle", CurrencyToggleController)

import DateRangeModalController from "./date_range_modal_controller"
application.register("date-range-modal", DateRangeModalController)

import DateRangeTriggerController from "./date_range_trigger_controller"
application.register("date-range-trigger", DateRangeTriggerController)

import DriveImportController from "./drive_import_controller"
application.register("drive-import", DriveImportController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterMoreController from "./filter_more_controller"
application.register("filter-more", FilterMoreController)

import FastInitController from "./fast_init_controller"
application.register("fast-init", FastInitController)

import FastInitProgressController from "./fast_init_progress_controller"
application.register("fast-init-progress", FastInitProgressController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import StatementProgressController from "./statement_progress_controller"
application.register("statement-progress", StatementProgressController)

import GooglePickerController from "./google_picker_controller"
application.register("google-picker", GooglePickerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InsightsController from "./insights_controller"
application.register("insights", InsightsController)

import MovementStatsController from "./movement_stats_controller"
application.register("movement-stats", MovementStatsController)

import PeriodFilterController from "./period_filter_controller"
application.register("period-filter", PeriodFilterController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import RowIndexToggleController from "./row_index_toggle_controller"
application.register("row-index-toggle", RowIndexToggleController)

import SheetOpenerController from "./sheet_opener_controller"
application.register("sheet-opener", SheetOpenerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import StatementFormatController from "./statement_format_controller"
application.register("statement-format", StatementFormatController)

import StatementPollingController from "./statement_polling_controller"
application.register("statement-polling", StatementPollingController)

import SubmitFeedbackController from "./submit_feedback_controller"
application.register("submit-feedback", SubmitFeedbackController)

import UploadModeController from "./upload_mode_controller"
application.register("upload-mode", UploadModeController)

import ViewModeController from "./view_mode_controller"
application.register("view-mode", ViewModeController)
